import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Button, Menu, MenuItem } from 'react-aria-menubutton';
const filter = require('lodash/filter');
const uuid = require('uuid');
import { Row, Form, Button as RbButton } from 'react-bootstrap';

const Globals = require('../../../../app/globals');
const OrganizationActions = require('../../actions/OrganizationActions');
const OrganizationStore = require('../../stores/OrganizationStore');
const SubscriptionPlanStore = require('../../stores/SubscriptionPlanStore');
const SubscriptionPlanActions = require('../../actions/SubscriptionPlanActions');
import ErrorBox from './ErrorBox';
import SuccessBox from './SuccessBox';
const StringUtil = require('../../../../app/shared/StringUtil');

const propTypes = {
    payMethodTypes: PropTypes.array.isRequired,
    className: PropTypes.string,
    defaultOwnerEmail: PropTypes.string,
    showOwnerEmail: PropTypes.bool,
    completeCallback: PropTypes.func,
};

const defaultProps = {
    className: "",
    defaultOwnerEmail: '',
    showOwnerEmail: true,
    completeCallback: null
}

function getStateFromPlanStoreState(props, state) {
    // determine what plans are available to choose from
    const org_plans = filter(state.upgrade_plans, (plan) => {
        if (!Globals.users.is_org_account_type(plan.account_type)) {
            return false;
        }

        if (props.payMethodTypes.indexOf(plan.process_type) < 0) {
            return false;
        }

        return true;
    });

    let change = {
        org_plans: org_plans
    };
    if (org_plans.length === 1) {
        change.org_plan_id = org_plans[0].id;
    }
    else if (org_plans.length == 0) {
        change.org_plan_id = '';
    }

    return change;
}

class RegisterOrganization extends React.Component {
    constructor(props) {
        super(props);

        this.defaultFormState = {
            email: "",
            ownerEmail: props.defaultOwnerEmail,
            organizationName: "",
        };

        const planStoreState = getStateFromPlanStoreState(props,SubscriptionPlanStore.getState());
        this.state = {
            organizationStoreState: OrganizationStore.getState(),
            org_plans: [],
            org_plan_id: "",
            actionId: null,
            error: null,
            success: false,
            ...this.defaultFormState,
            ...planStoreState,
        };

        this.onRegister = this.onRegister.bind(this);
        this.onSelectOrgPlan = this.onSelectOrgPlan.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onChangeOwnerEmail = this.onChangeOwnerEmail.bind(this);
        this.onChangeOrgName = this.onChangeOrgName.bind(this);

        this.unsubscribes = [
            OrganizationStore.listen(this.onOrgStoreChange.bind(this)),
            SubscriptionPlanStore.listen(this.onPlanStoreChange.bind(this))
        ];

        // ask for subscription plans
        SubscriptionPlanActions.getUpgradePlans(uuid.v4());
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onOrgStoreChange(state) {
        let additionalState = {};
        if (state.action.id === this.state.actionId) {
            if (!state.action.error) {
                additionalState = {
                    ...additionalState, 
                    actionId: null,
                    error: null,
                    success: true,
                    ...this.defaultFormState
                };
                //report success

                if (this.props.completeCallback) {
                    this.props.completeCallback();
                }
            }
            else {
                //report failure
                additionalState = {
                    ...additionalState,
                    success: false,
                    actionId: null,
                    error: state.action.error
                };
            }
        }

        this.setState({
            organizationStoreState: state,
            ...additionalState
        });
    }

    onPlanStoreChange(state) {
        this.setState(getStateFromPlanStoreState(this.props,state));
    }

    onSelectOrgPlan(value) {
        this.setState({ org_plan_id: value });
    }

    onChangeEmail(e) {
        this.setState({ email: e.target.value });
    }

    onChangeOwnerEmail(e) {
        this.setState({ ownerEmail: e.target.value });
    }

    onChangeOrgName(e) {
        this.setState({ organizationName: e.target.value });
    }

    onRegister(e) {
        e.preventDefault(); // required to stop page from refreshing. TODO: isolate ancestor(?) causing this behavior?
        e.stopPropagation();

        const actionId = uuid.v4();
        this.setState({ actionId: actionId, success: false }, () => {
            OrganizationActions.registerOrganization(actionId, {
                email: this.state.email,
                ownerEmail: this.state.ownerEmail,
                organizationName: this.state.organizationName,
                org_plan_id: this.state.org_plan_id,
                // accountType: this.state.accountType
            });
        });
    }

    render() {
        let selectedPlan;
        const planMenuItems = this.state.org_plans.map((plan) => {
            let itemClass = 'AriaMenuButton-menuItem';
            if (this.state.org_plan_id === plan.id) {
                itemClass += ' is-selected';
                selectedPlan = plan;
            }

            return (
                <li className='AriaMenuButton-menuItemWrapper' key={plan.id}>
                    <MenuItem
                        className={itemClass}
                        value={plan.id}
                        text={plan.display_name}
                    >
                        {plan.display_name}
                    </MenuItem>
                </li>
            );
        });

        return (
            <div className={this.props.className}>
                <ErrorBox error={this.state.error}/>
                {(this.state.success) &&
                    <SuccessBox>Organization successfully registered</SuccessBox>
                }
                <Form>
                    <Row>
                        <Form.Group
                            className="col-12 col-sm-6"
                            controlId="reg-org-owner-email"
                        >
                        {/*validationState={this.getValidationState('email')}>*/}
                            <Form.Label>organization email</Form.Label>
                            <Form.Control
                                value={this.state.email}
                                onChange={this.onChangeEmail}
                            />
                        </Form.Group>
                        {(this.props.showOwnerEmail) &&
                            <Form.Group
                                className="col-12 col-sm-6"
                                controlId="reg-org-org-email"
                            >
                            {/*validationState={this.getValidationState('ownerEmail')}>*/}
                                <Form.Label>owner email</Form.Label>
                                <Form.Control
                                    value={this.state.ownerEmail}
                                    onChange={this.onChangeOwnerEmail}
                                />
                            </Form.Group>
                        }
                    </Row>
                    <Row>
                        <Form.Group className="col-12 col-sm-6" controlId="reg-org-org-name">
                        {/*validationState={this.getValidationState('organizationName')}>*/}
                            <Form.Label>organization name</Form.Label>
                            <Form.Control
                                value={this.state.organizationName}
                                onChange={this.onChangeOrgName}
                            />
                        </Form.Group>
                        <div className="org-plan-chooser col-12 col-sm-6">
                            <label htmlFor="plan-interval">plan</label>
                            <Wrapper id="plan-interval" className='AriaMenuButton margin-left-sm' onSelection={this.onSelectOrgPlan}>
                                <Button className='AriaMenuButton-trigger'>
                                    {selectedPlan ? selectedPlan.display_name : 'select a plan'}
                                </Button>
                                <Menu>
                                    <ul className='AriaMenuButton-menu'>
                                        {planMenuItems}
                                    </ul>
                                </Menu>
                            </Wrapper>
                        </div>
                    </Row>
                    <div className="text-right margin-top-md">
                        <RbButton onClick={this.onRegister}>
                            Register
                        </RbButton>
                    </div>
                </Form>
            </div>
        )
    }
}

RegisterOrganization.propTypes = propTypes;
RegisterOrganization.defaultProps = defaultProps;

export default RegisterOrganization;